import { render, staticRenderFns } from "./FaceSelectPanel.vue?vue&type=template&id=b14bd350&scoped=true&"
import script from "./FaceSelectPanel.vue?vue&type=script&lang=js&"
export * from "./FaceSelectPanel.vue?vue&type=script&lang=js&"
import style0 from "./FaceSelectPanel.vue?vue&type=style&index=0&id=b14bd350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14bd350",
  null
  
)

export default component.exports